export default __webpack_public_path__ + "static/media/yoanne.a0bd7dc3.jpg";